import type { CellProps } from 'react-table';
import type { TranscriptsTableItem } from './interfaces';
import { Tags } from './Tags';

export default function TranscriptTags({ row: { original: data } }: CellProps<TranscriptsTableItem>) {
  return <Tags tags={data.tags} maxTags={1} />;
}

export { TranscriptTags };